import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { locations } from 'services/routes/locations';
import { AudioProvider } from 'services/contexts/AudioProvider';
import { selectReleaseSongs } from 'services/store/distribution/selectors';
import { useTracklistValidation } from 'pages/Distribution/hooks';
import { TracklistHeader, TracklistSummary, TracklistItem } from './components';
import { StyledContainer, TracklistContainer, ConfirmButton } from './styled';

type PropsType = {
  releaseId: string;
};

const Info = ({ releaseId }: PropsType) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const songs = useSelector(selectReleaseSongs(releaseId));

  const { isValid } = useTracklistValidation(releaseId);

  const handleGoToReleaseDetails = useCallback(
    () => navigate(locations.distribution.details.pathname(releaseId)),
    [releaseId, navigate]
  );

  return (
    <StyledContainer>
      <TracklistContainer>
        <TracklistHeader />
        <AudioProvider>
          {songs?.map((song) => (
            <TracklistItem key={song.id} releaseId={releaseId} song={song} />
          ))}
        </AudioProvider>
        <TracklistSummary songs={songs} />
      </TracklistContainer>
      <ConfirmButton disabled={!isValid} onClick={handleGoToReleaseDetails}>
        {t('distribution:tracklist:actions:confirm')}
      </ConfirmButton>
    </StyledContainer>
  );
};

export default Info;
